<button
  class="button--base button--{{ type }} button--{{ shape }} button--{{
    size
  }} button--spacingBottom-{{ spacingBottom }}"
  [ngClass]="{
    'button--error': error()
  }"
  [attr.data-test-id]="testId"
  [disabled]="disabled"
  (click)="onClick()"
  [type]="nativeType"
>
  <svg
    *ngIf="buttonIcon === ButtonIcon.DOCUMENT"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z"
      fill="currentColor"
    />
  </svg>
  <svg
    *ngIf="buttonIcon === ButtonIcon.EMAIL"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
      fill="currentColor"
    />
  </svg>
  <svg
    *ngIf="buttonIcon === ButtonIcon.PLUS"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="10" y="4" width="4" height="16" fill="currentColor" />
    <rect x="4" y="10" width="16" height="4" fill="currentColor" />
  </svg>
  <svg
    *ngIf="buttonIcon === ButtonIcon.X"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3337 6.03033L13.364 12L19.3337 17.9697C19.8218 18.4578 19.8218 19.2422 19.3337 19.7303C18.8456 20.2184 18.0612 20.2184 17.5731 19.7303L11.6034 13.7606L5.63371 19.7303C5.14563 20.2184 4.36119 20.2184 3.87311 19.7303C3.38503 19.2422 3.38503 18.4578 3.87311 17.9697L9.84278 12L3.87311 6.03033C3.38503 5.54225 3.38503 4.75781 3.87311 4.26973C4.36119 3.78165 5.14563 3.78165 5.63371 4.26973L11.6034 10.2394L17.5731 4.26973C18.0612 3.78165 18.8456 3.78165 19.3337 4.26973C19.8218 4.75781 19.8218 5.54225 19.3337 6.03033Z"
      fill="currentColor"
    />
  </svg>
  <svg
    *ngIf="buttonIcon === ButtonIcon.CHECK"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71C20.6801 7.32 20.6801 6.69 20.2901 6.3C19.9001 5.91 19.2701 5.91 18.8801 6.3L9.00014 16.17Z"
      fill="currentColor"
    />
  </svg>
  <ng-content></ng-content>
</button>
